import { gql } from '@apollo/client';

export const GET_APPLICATIONS = gql`
  query GetApplications($jobId: String!, $limit: Int, $offset: Int, $startDate: Float, $endDate: Float, $search: String, $showAll: Boolean) {
    applications(jobId: $jobId, limit: $limit, offset: $offset, startDate: $startDate, endDate: $endDate, search: $search, showAll: $showAll) {
      items {
        _id
        stage
        user {
          _id
          firstName
          lastName
          email
          avatarUrl
        }
        talent {
          _id
          linkedin
          pdfUrl
        }
        interview {
          _id
          isFinished
          durations
          recording {
            _id
            state
          }
        }
        questionnaire {
          _id
          passed
          questions
          answers
        }
        evaluation
        updatedAt
      }
      totalCount
    }
  }
`;

export default GET_APPLICATIONS;
